import SharedContactsGrid from '../../directory/shared-contacts/shared-contacts-grid';
import { pagesConfig } from '../../../shared/pages-config';
import { useUserSettings } from '../../../utils/use-user-settings';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';

export default function SharedContactsPage() {
  const { viewType } = useUserSettings();

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.directory.name },
        { label: pagesConfig.sharedContacts.name },
      ]}
      bookmarkKey={pagesConfig.sharedContacts.value}
    >
      <SharedContactsGrid
        key={viewType.sharedContactsGridStates?.activeGridState || 'default'}
      />
    </SimpleBreadcrumbsPage>
  );
}
